import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { QueryClient, QueryClientProvider } from "react-query";
import { CookieConsent } from "./components/CookieConsent/CookieConsent";
import { AppContent } from "./components/AppContent";
import { HelmetProvider } from "react-helmet-async";
import { Card, Col } from "antd";

const queryClient = new QueryClient();

const App = () => {
  return (
    <HelmetProvider>
      <CookieConsent
        datenschutzUrl={
          "https://mayasolutions.de/datenschutzerklaerung-fuer-werbinich-web-app"
        }
        cookieName={"cookiesAccepted"}
        someAcceptedComp={<SomeCookiesComp />}
        allAcceptedComp={
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <BrowserRouter>
                <AppContent />
              </BrowserRouter>
            </Provider>
          </QueryClientProvider>
        }
      />
    </HelmetProvider>
  );
};

export default App;

const SomeCookiesComp = () => {
  return (
    <Col span={18}>
      <Card title={"Wer Bin ich?"} size={"small"}>
        <p>Hier findest du eine Anleitung für Wer bin ich:</p>
        <p>
          <a
            href={"https://de.wikipedia.org/wiki/Wer_bin_ich%3F_(Spiel)"}
            target={"_blank"}
            rel={"noreferrer"}
          >
            https://de.wikipedia.org/wiki/Wer_bin_ich%3F_(Spiel)
          </a>
        </p>
      </Card>
    </Col>
  );
};
